import { ObservedElements, useInView, useMediaQuery } from 'hooks';
import { LayoutContainer } from 'layout';
import { Dots, DotsScrollCard, SectionContainer } from 'ui';

import { DonutCard } from './donutCard';
import {
    screenTablet,
    sectionContainer,
    statisticContainer,
    statisticWrapper,
    layoutContainerOverride
} from './donut-charts-section.module.scss';
import { useEffect, useRef, useState } from 'react';

const donutCards: DotsScrollCard[] = [
    {
        name: '0',
        percentage: 83,
        text: 'Physicians unsatisfied with their current knowledge organization',
        duration: (83 / 100) * 1.25,
        isActive: false
    },
    {
        name: '1',
        percentage: 92,
        text: 'Academic professionals agree on staying up-to-date via lifelong learning',
        duration: (92 / 100) * 1.25,
        isActive: false
    },
    {
        name: '2',
        percentage: 84,
        text: 'Researchers that complain about publication and information overload',
        duration: (84 / 100) * 1.25,
        isActive: false
    }
];
export const DonutChartsSection = () => {
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);
    const [currentVisibleIndex, setCurrentVisibleIndex] = useState(-1);
    const donutRefs = useRef<HTMLDivElement[]>([]);
    const addCardToRefs = (el: HTMLDivElement) => {
        if (el && !donutRefs.current.includes(el)) donutRefs.current.push(el);
    };
    const observedDonuts = useInView(donutRefs, { threshold: 0.5 });

    const handleDotClick = (index: number) => {
        donutRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    useEffect(() => {
        let currentVisibleIndex = -1;
        const castedObservedDonuts = observedDonuts as ObservedElements;
        for (const key in castedObservedDonuts) {
            if (castedObservedDonuts[key].isInView) {
                if (!isTablet) {
                    currentVisibleIndex = Number(key);
                    donutCards[currentVisibleIndex].isActive = true;
                    break;
                } else {
                    currentVisibleIndex = 0;
                    donutCards[Number(key)].isActive = true;
                }
            }
        }
        setCurrentVisibleIndex(currentVisibleIndex);
    }, [isTablet, observedDonuts]);

    return (
        <LayoutContainer className={layoutContainerOverride}>
            <SectionContainer className={sectionContainer}>
                <div className={statisticContainer}>
                    {donutCards.map(({ percentage, text, duration, isActive }, index) => (
                        <div key={index} className={statisticWrapper}>
                            <DonutCard
                                ref={addCardToRefs}
                                percentage={percentage}
                                text={text}
                                duration={duration}
                                index={index}
                                isActive={isActive}
                            />
                        </div>
                    ))}
                </div>
                {!isTablet && (
                    <Dots
                        cards={donutCards}
                        activeIndex={currentVisibleIndex}
                        handleDotClick={index => handleDotClick(index)}
                    />
                )}
                <span>Source: EANS survey 2016 & 2022</span>
            </SectionContainer>
        </LayoutContainer>
    );
};
